import { AutoSweepAuditStatus, DestinationTypeEnum, WhiteListAuditStatus } from '@/constants/enum'
import { Pagination } from '../BaseModel'
import { SweepDestinationType } from '../sweep/models'

export enum WhiteListAuditStatusEnum {
  audit = 0,
  passed = 1,
  rejected = 2,
}

export enum QueryAddressTypeEnum {
  addressbook = 1,
  whitelist = 2,
}
export enum ErrorCodeTypeEnum {
  // 名称重复
  NAMEDUPLICATION = 2046,
  // 地址重复
  ADRESSDUPLICATION = 2003,
  // 存在交易
  TRANSACTIONEXIST = 2056,
  // 格式错误
  FORMATERROR = 3008,
}
export interface GetAddressBookListDTO {
  blockchainTypeKey?: string
  auditStatus?: WhiteListAuditStatusEnum
  type?: QueryAddressTypeEnum
  queryStr?: string
  page?: number
  pageSize?: number
}

export interface GetAddressBookCountDTO {
  blockchainTypeKey: string
  auditStatus?: WhiteListAuditStatusEnum
  type?: QueryAddressTypeEnum
}
export interface UpdateAddressBookDTO {
  name: string
  address: string
  addressBookKey: string
  timestamp?: number
}
export interface AddAddressBookDTO {
  name: string
  blockchainTypeKey: string
  address: string
}
export interface AddWhiteListSign {
  addressBookKey: string
  timestamp: number
}
export interface delAddressBookDTO {
  addressBookKey: string
  timestamp: number
}
export interface AddressBookModel {
  blockchainTypeName: string
  blockchainTypeKey: string
  addressBookKey: string
  address: string
  type: 1 | 2
  addressName: string
  memo: string | null
  auditStatus: WhiteListAuditStatus
  activeStatus: boolean
}

export enum AccountTag {
  NONE = 'NONE',
  DEPOSIT = 'DEPOSIT',
}

export interface AutoSweepAddressBookModel {
  blockchainTypeName: string
  blockchainTypeKey: string
  addressBookKey: string
  address: string
  auditStatus: WhiteListAuditStatusEnum
  accountTag: AccountTag
  type: QueryAddressTypeEnum
  addressName: string
}

export type AutoSweepAddressBookListModel = Pagination<AutoSweepAddressBookModel>

export enum AutoSweepOperateType {
  'AUTOSWEEP_RULE_UPDATE' = 'AUTOSWEEP_RULE_UPDATE',
  'AUTOSWEEP_RULE_ADD' = 'AUTOSWEEP_RULE_ADD',
  'AUTOSWEEP_RULE_DEL' = 'AUTOSWEEP_RULE_DEL',
}
export interface AutoSweepRuleModel {
  destinationName: string
  initiatorUserKey: string
  initiatorUserName: string
  networkKey: string
  networkName: string
  networkLogo: string
  blockchainTypeName: string
  destinationType: DestinationTypeEnum
  destinationId: string
  destinationAddress: string
  triggerAmountUsd: number
  sweepRate: number
  maxFeeLimit: number
  remainGas: number
  openGasStation: boolean
  gasStationAccountKey: string
  gasStationAddress: string
  onceRefillGas: number
  nativeSymbol: string
  auditUserList: string[]
  auditUserDtoList: { userKey: string; userName: string }[]
  activeStatus: number
  auditStatus: AutoSweepAuditStatus
  operateType: AutoSweepOperateType
  modifyKey: string
  alreadyScanStatus: boolean
}

export interface AutoSweepRuleDetailModel extends Omit<AutoSweepRuleModel, 'modifyKey'> {
  gasStationAccountName: string
  gasStationAccountBalance: string
  gasStationAccountType: SweepDestinationType
  modifyKey: string
  destinationName: string
  auditInfo: AuditInfoModel
  forbidAml: boolean
}
export interface AuditInfoModel {
  initiatorTime: number
  initiatorUserKey: string
  initiatorUserName: string
  initiatorUserPortrait: string
  thresholdM?: number
  auditList: AuditListModel[]
}
export interface AuditListModel {
  auditTime: number
  auditType: number
  auditUserName: string
  auditUserKey: string
  auditUserPortrait: string
  isDeleted?: boolean
}
